import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import BasicBackground from '../BasicBackground';
import { globalStyles } from '../style/gstheme';
import PrimaryButton from '../PrimaryButton';

const styles = theme => {
  return Object.assign({
  }, globalStyles)
};

class TooLateToReset extends Component {

  tryAgain = () => {
    this.props.history.push("/forgotten")
  }

  render() {

    const { classes } = this.props;
    return (
      <BasicBackground>
        <div style={{ width: '100%', position: 'absolute', top: 100, textAlign: 'center' }}>
          <Typography className={classes.mainHeadingLight}>Password Reset Lapsed</Typography>
          <PrimaryButton onClick={this.tryAgain}>Try Resetting Again</PrimaryButton>
        </div>
      </BasicBackground>
    );
  }
}

TooLateToReset.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object
}

export default withRouter(withStyles(styles)(TooLateToReset));